import React from 'react';
import PropTypes from 'prop-types';
import CheckboxInput from 'components/connectedForm/CheckboxInput';
import EditorContainerWrapper from 'components/EditorContainerWrapper';
import isEvent from 'components/connectedForm/utils/isEvent';

export default class CheckboxInputEditor extends EditorContainerWrapper {
  constructor(props) {
    super(props);
  }

  // Decide which editor to use based on the attribute type of the current row
  getEditorComponent = () => {
    return CheckboxInput;
  };

  // Set extra props, such as validation
  getEditorProps = () => {
    let editorProps = { inGrid: true };
    return editorProps;
  };

  onChange = (event) => {
    let newValue = true;
    if (isEvent(event)) {
      const {
        target: { type, checked },
      } = event;
      if (type === 'checkbox') {
        newValue = checked;
      }
    }
    this.setState({ currentValue: newValue }, () => {
      this.props.onCommit();
    });
  };

  getKey = () => {
    return this.props.column.key;
  };

  getValue() {
    var updated = {};
    updated[this.props.column.key] = typeof this.state.currentValue === 'boolean' ? this.state.currentValue : false;
    return updated;
  }
}

CheckboxInput.propTypes = {
  active: PropTypes.bool,
  mandatory: PropTypes.bool,
  onBlur: PropTypes.func,
  onFocus: PropTypes.func,
  onChange: PropTypes.func,
  includeLabel: PropTypes.bool,
  readOnly: PropTypes.bool,
  flexBox: PropTypes.bool,
  cols: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  id: PropTypes.string,
  hint: PropTypes.string,
  value: PropTypes.bool,
  message: PropTypes.array,
  showWhenNotActive: PropTypes.bool,
  label: PropTypes.string,
};

CheckboxInput.defaultProps = {
  active: false,
  mandatory: false,
  onBlur: () => {},
  onFocus: () => {},
  onChange: () => {},
  includeLabel: true,
  readOnly: false,
  flexBox: true,
  cols: 'min',
  value: false,
  message: [],
  hint: '',
  showWhenNotActive: false,
  label: '',
  id: '',
};
